import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoJsService {

  constructor() { }

  Encrypt(text: string) {
    let _key = CryptoJS.enc.Utf8.parse("/<du3]@D33Asr3@X");
    let _iv = CryptoJS.enc.Utf8.parse("/<du3]@D33Asr3@X");
    let encrypted = CryptoJS.AES.encrypt(
      text, _key, {
      keySize: 128,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
    });
    return encrypted.toString();
  }



  DecryptData(obj: any) {
    let _key = CryptoJS.enc.Utf8.parse("/<du3]@D33Asr3@X");
    let _iv = CryptoJS.enc.Utf8.parse("/<du3]@D33Asr3@X");

    let decrypted = CryptoJS.AES.decrypt(
      obj, _key, {
      keySize: 128,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

}
